export const states = [
  { name: 'Rondônia', value: 'RO' },
  { name: 'Acre', value: 'AC' },
  { name: 'Amazonas', value: 'AM' },
  { name: 'Roraima', value: 'RR' },
  { name: 'Pará', value: 'PA' },
  { name: 'Amapá', value: 'AP' },
  { name: 'Tocantins', value: 'TO' },
  { name: 'Maranhão', value: 'MA' },
  { name: 'Piauí', value: 'PI' },
  { name: 'Ceará', value: 'CE' },
  { name: 'Rio Grande do Norte', value: 'RN' },
  { name: 'Paraíba', value: 'PB' },
  { name: 'Pernambuco', value: 'PE' },
  { name: 'Alagoas', value: 'AL' },
  { name: 'Sergipe', value: 'SE' },
  { name: 'Bahia', value: 'BA' },
  { name: 'Minas Gerais', value: 'MG' },
  { name: 'Espírito Santo', value: 'ES' },
  { name: 'Rio de Janeiro', value: 'RJ' },
  { name: 'São Paulo', value: 'SP' },
  { name: 'Paraná', value: 'PR' },
  { name: 'Santa Catarina', value: 'SC' },
  { name: 'Rio Grande do Sul', value: 'RS' },
  { name: 'Mato Grosso do Sul', value: 'MS' },
  { name: 'Mato Grosso', value: 'MT' },
  { name: 'Goiás', value: 'GO' },
  { name: 'Distrito Federal', value: 'DF' },
].sort((a, b) => a.name.localeCompare(b.name));



// WEBPACK FOOTER //
// ./src/utils/address.js